// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2e9Rt","selected":"Chip_selected__3bALK"};